<template>
  <v-expansion-panel class="pt-2">
    <v-expansion-panel-header class="expansion--panel">
      <template>
        <v-row no-gutters>
          <v-col cols="4"><v-icon color="white">mdi-file-multiple</v-icon> {{ $t('message.product.attachments') }}</v-col>
        </v-row>
      </template>
    </v-expansion-panel-header>
    <v-expansion-panel-content class="pt-2">
      <div>
        <document-manager class="pa-1" :modelObj="modelObj" :key="reloadDocs" :module="module"></document-manager>
      </div>
    </v-expansion-panel-content>
 </v-expansion-panel>
</template>
<script>
export default {
  props: ['model', 'module'],
  data () {
    return {
      modelObj: this.model,
      filelist: [],
      reloadDocs: 0
    }
  },
  components: {
    'document-manager': () => import('@/components/Documents/ModulesDocuments')
  },
  mounted () {
    this.$root.$on('reload_docs', () => {
      this.reloadDocs++
    })
  },
  beforeDestroy () {
    this.$root.$off('reload_docs')
  }
}
</script>
